import React, { useContext } from 'react';

import { context } from './context';

import { Props } from './BCResult.types';
import { Styled } from './BCResult.styles';
import { TextField } from 'office-ui-fabric-react';

export const GainedTickets: React.FC<Props> = () => {
  const { tickets, resultTask, setResultTask } = useContext(context);

  return (
    <Styled.MainBlock>
      <h2>Получено билетов</h2>
      <div>
        {tickets.map(({ id, name }) =>
          (
            <Styled.InputWrapper key={id}>
              <span>{name}</span>
              <TextField
                value={`${resultTask?.check_tickets[id] || 0}`}
                type="number"
                onChange={(_, value) => {
                  setResultTask((prev) => {
                    if (!prev) return null;
                    return {
                      ...prev,
                      check_tickets: {
                        ...prev.check_tickets,
                        [id]: Number(value),
                      },
                    };
                  });
                }}
              />
            </Styled.InputWrapper>
          ))}
      </div>
    </Styled.MainBlock>
  );
};
